import React from "react";
import CyberCareerSkills from "../components/Courses/CyberSecurity/CareerSkillsSection";
import CyberAdmissionRequ from "../components/Courses/CyberSecurity/CyberAdmissionReq";
import CyberSecurityHeader from "../components/Courses/CyberSecurity/CyberSecurityHeader";
import CyberSecurityProgramsCard from "../components/Courses/CyberSecurity/ExploreProgramsCyber";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const CyberSec = () => {
  return (
    <div>
      <Navbar />
      <CyberSecurityHeader />
      <CyberCareerSkills />
      <CyberSecurityProgramsCard />
      <CyberAdmissionRequ />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default CyberSec;
